"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const formatPrice = function (price) {
  let currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "EUR";
  let locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "de-DE";
  if (price === "" || price === null || price === undefined) return;
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency
  }).format(price);
};
var _default = exports.default = formatPrice;